import { Component, OnInit, Input, Output, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { AppService, AppDateAdapter, APP_DATE_FORMATS } from "../../services/app.service";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material";
import { ReportService } from '../../services/reports.service';
import { ComponentService } from '../../services/component.service';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: 'app-billofloading',
    templateUrl: './billofloading.component.html',
    styleUrls: ['./billofloading.component.scss'],
    providers: [
        {
            provide: DateAdapter, useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
        }
    ]
})
export class BillofloadingComponent implements OnInit {
    formGroup: FormGroup;
    formGroupErrors: any;
    invalidForm = true;
    shipdate: any = { ShipDate: ""  };
    translations: any;
    pdfLink : String = '';
constructor(public sanitizer: DomSanitizer,private reportService: ReportService,private formBuilder: FormBuilder, public appService: AppService, public comService :ComponentService) {
    this.appService.hideLoading();
    this.formGroupErrors = {
        ShipDate: {}
    };

    this.formGroup = this.formBuilder.group({
        ShipDate: ["", Validators.required]
    });
}

setPageTranslations(){
    this.comService.get('billofloading').subscribe((res) => {
      this.translations = JSON.parse(res['Data']);
      this.appService.hideLoading();
    });
}

ngOnInit() {
    this.setPageTranslations();
    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(      
            this.formGroup,
            this.formGroupErrors
        );
        if(!this.formGroup.invalid){
            this.invalidForm = false;
        }
        else{
            this.invalidForm = true;
        }
    });
    this.setPageTranslations();
}

generate(){
    this.shipdate.ShipDate = this.appService.JSONDate(this.shipdate.ShipDate);
    this.appService.showLoading();
    this.reportService
        .generateBillOfLoading(JSON.stringify(this.shipdate))
        .subscribe(
        res => this.reportSuccess(res),
        error => this.apiFaillure(error)
    );
}
reportSuccess(res){
    this.appService.hideLoading();
    var data = JSON.parse(res.Data);
    if(data == ""){
        this.appService.showDialogue(this.translations["hdrInfo"], this.translations["msgNoDataAvailable"]);
    }
    else{
        //this.pdfLink = data;
        window.open(data,'_blank');
    }
}
getPDFUrl(){
    return this.sanitizer.bypassSecurityTrustUrl(this.pdfLink.toString());
}
apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(this.translations["hdrError"], "Please try again"
    //      this.translations.hdError,
    //      this.translations[error]
    );
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/billofloading/billofloading.component.ts